import { render, staticRenderFns } from "./order-picker.mpx?vue&type=template&id=04a10b26&isComponent&outputPath=components%2Forder-pickerc8b8e65c%2Findex"
import script from "./order-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Forder-pickerc8b8e65c%2Findex"
export * from "./order-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Forder-pickerc8b8e65c%2Findex"
import style0 from "./order-picker.mpx?vue&type=style&index=0&id=04a10b26&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_c8b8e65c%22%7D&isComponent&outputPath=components%2Forder-pickerc8b8e65c%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports